"use strict";
var __spreadArrays = (this && this.__spreadArrays) || function () {
    for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
    for (var r = Array(s), k = 0, i = 0; i < il; i++)
        for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
            r[k] = a[j];
    return r;
};
Object.defineProperty(exports, "__esModule", { value: true });
var globals_1 = require("./globals");
var constants_1 = require("./constants");
var subscribers = {};
exports.addSubscriber = function (webSocketInstance, url, setters, options, reconnect, reconnectCount, expectClose, sendMessage) {
    if (options === void 0) { options = {}; }
    var setLastMessage = setters.setLastMessage, setReadyState = setters.setReadyState;
    var reconnectTimeout;
    if (subscribers[url] === undefined) {
        subscribers[url] = [];
        webSocketInstance.onmessage = function (message) {
            if (typeof options.filter === 'function' && options.filter(message) !== true) {
                return;
            }
            subscribers[url].forEach(function (subscriber) {
                subscriber.setLastMessage(message);
                if (subscriber.options.onMessage) {
                    subscriber.options.onMessage(message);
                }
            });
        };
        webSocketInstance.onclose = function (event) {
            var _a, _b;
            subscribers[url].forEach(function (subscriber) {
                if (expectClose.current === false) {
                    subscriber.setReadyState(function (prev) {
                        var _a;
                        return Object.assign({}, prev, (_a = {}, _a[url] = constants_1.ReadyState.CLOSED, _a));
                    });
                }
                if (subscriber.options.onClose) {
                    subscriber.options.onClose(event);
                }
            });
            globals_1.sharedWebSockets[url] = undefined;
            var subscribersToReconnect = __spreadArrays(subscribers[url]);
            subscribers[url] = undefined;
            if (options.shouldReconnect && options.shouldReconnect(event)) {
                var reconnectAttempts = (_a = options.reconnectAttempts, (_a !== null && _a !== void 0 ? _a : constants_1.DEFAULT_RECONNECT_LIMIT));
                if (reconnectCount.current < reconnectAttempts) {
                    if (expectClose.current === false) {
                        reconnectTimeout = setTimeout(function () {
                            reconnectCount.current++;
                            subscribersToReconnect.forEach(function (subscriber) {
                                subscriber.reconnect();
                            });
                        }, (_b = options.reconnectInterval, (_b !== null && _b !== void 0 ? _b : constants_1.DEFAULT_RECONNECT_INTERVAL_MS)));
                    }
                }
                else {
                    console.error("Max reconnect attempts of " + reconnectAttempts + " exceeded");
                }
            }
        };
        webSocketInstance.onerror = function (error) {
            subscribers[url].forEach(function (subscriber) {
                if (subscriber.options.onError) {
                    subscriber.options.onError(error);
                }
            });
        };
        webSocketInstance.onopen = function (event) {
            reconnectCount.current = 0;
            subscribers[url].forEach(function (subscriber) {
                if (expectClose.current === false) {
                    subscriber.setReadyState(function (prev) {
                        var _a;
                        return Object.assign({}, prev, (_a = {}, _a[url] = constants_1.ReadyState.OPEN, _a));
                    });
                }
                if (subscriber.options.onOpen) {
                    subscriber.options.onOpen(event, sendMessage);
                }
            });
        };
    }
    else {
        setReadyState(function (prev) {
            var _a;
            return Object.assign({}, prev, (_a = {}, _a[url] = globals_1.sharedWebSockets[url].readyState, _a));
        });
    }
    var subscriber = {
        setLastMessage: setLastMessage,
        setReadyState: setReadyState,
        options: options,
        reconnect: reconnect,
    };
    subscribers[url].push(subscriber);
    return function () {
        if (reconnectTimeout)
            clearTimeout(reconnectTimeout);
        if (subscribers[url] !== undefined) {
            var index = subscribers[url].indexOf(subscriber);
            if (index === -1) {
                throw new Error('A subscriber that is no longer registered has attempted to unsubscribe');
            }
            if (subscribers[url].length === 1) {
                subscribers[url][0].setReadyState(function (prev) {
                    var _a;
                    return Object.assign({}, prev, (_a = {}, _a[url] = constants_1.ReadyState.CLOSING, _a));
                });
                webSocketInstance.close();
            }
            else {
                subscribers[url].splice(index, 1);
            }
        }
    };
};
//# sourceMappingURL=add-subscriber.js.map